import { createGlobalStyle } from "styled-components";

const globalStyle = createGlobalStyle`
  /* Nothing Design System — CSS Variables (Dark Mode) */
  :root {
    --nd-black: #000000;
    --nd-surface: #111111;
    --nd-surface-raised: #1A1A1A;
    --nd-border: #222222;
    --nd-border-visible: #333333;
    --nd-text-disabled: #666666;
    --nd-text-secondary: #999999;
    --nd-text-primary: #E8E8E8;
    --nd-text-display: #FFFFFF;
    --nd-accent: #D71921;
    --nd-accent-subtle: rgba(215,25,33,0.15);
    --nd-success: #4A9E5C;
    --nd-warning: #D4A843;
    --nd-interactive: #5B9BF6;
  }

  body {
    background-color: var(--nd-black) !important;
    color: var(--nd-text-primary) !important;
    font-family: 'Space Grotesk', -apple-system, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  p, .p {
    color: var(--nd-text-primary);
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.5;
    margin-bottom: 0;
    font-family: 'Space Grotesk', sans-serif;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Space Grotesk', sans-serif !important;
    color: var(--nd-text-display) !important;
  }

  ul, .ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  a {
    transition: all 250ms cubic-bezier(0.25, 0.1, 0.25, 1);
    color: var(--nd-text-primary) !important;
    &:hover, &:active, &:focus {
      text-decoration: none !important;
      outline: none !important;
      color: var(--nd-text-display) !important;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  /* Dot grid background motif */
  .nd-dot-grid {
    background-image: radial-gradient(circle, var(--nd-border-visible) 1px, transparent 1px);
    background-size: 16px 16px;
  }

  /* Override Bootstrap / existing theme for Nothing style */
  .navbar, nav {
    background: var(--nd-black) !important;
    border-bottom: 1px solid var(--nd-border) !important;
  }

  /* Scrollbar */
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: var(--nd-black); }
  ::-webkit-scrollbar-thumb { background: var(--nd-border-visible); border-radius: 3px; }
`;

export default globalStyle;
